import { FunctionComponent } from 'react';
import classnames from 'classnames';

import StyledComponent from './styles';
import { Props } from './types';

const LayoutModal: FunctionComponent<Props> = ({ children, title, onClose, stepBack, allowStepBack, zIndex, forbidOnClose, className }) => {
    const handleCloseModal = () => {
        if (allowStepBack && stepBack) return stepBack();
        return onClose();
    };

    return (
        <StyledComponent className={classnames('layout-modal', zIndex && 'z-index-top', className)}>
            <div
                className="modal-backdrop"
                onClick={() => {
                    if (forbidOnClose) return;
                    onClose && handleCloseModal();
                }}
            />

            <div className="modal-container-wrapper">
                {onClose && (
                    <a
                        className="modal-close-button"
                        onClick={handleCloseModal}
                    >
                        <div className="icon" />
                    </a>
                )}
                <div className="modal-container">

                    <div className="modal-header">
                        {title && (
                            <h3 className="modal-header-title">
                                {title}
                            </h3>
                        )}
                    </div>

                    <div className="modal-body">
                        {children}
                    </div>
                </div>
            </div>
        </StyledComponent>

    );
};

export default LayoutModal;
